import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {PaypalConfig} from "./config/paypal.config";
import {BitcoinAppService} from "../../service/bitcoin-app/bitcoin-app.service";

@Component({
    selector: 'app-bitcoin-app',
    templateUrl: './bitcoin-app.component.html',
    styleUrls: ['./bitcoin-app.component.scss']
})
export class BitcoinAppComponent implements OnInit, OnDestroy {

    @Input() show = false;
    @Input() loaded = false;
    @Input() src = '';
    @Input() shortName = '';

    @Output('onClose') emitClose: EventEmitter<any> = new EventEmitter();

    safeUrl;
    activeClass = false;

    contentLoaded = false;
    paypalOpening = false;
    openPaypalTimeout: any;

    constructor(private sanitizer: DomSanitizer,
                private bitcoinAppService: BitcoinAppService) {}

    ngOnInit(): void {
      this.activeClass = true;
      this.safeUrl = this.getUrl();
    }

    ngOnChanges(changes) {
      if (changes && changes.loaded) {
        console.log(changes)
        this.contentLoaded = changes.loaded.currentValue;
      }
    }

    ngOnDestroy() {
      this.contentLoaded = false;
      this.activeClass = false;
    }

    handleClose(): void {
        this.contentLoaded = false;
        this.emitClose.emit();
    }

    getUrl() {
      return this.sanitizer.bypassSecurityTrustResourceUrl(this.src);
    }

  isPaypalIframe(): boolean {
    return this.shortName === PaypalConfig.pyusdShortName ||
           this.shortName === PaypalConfig.redeemPyusdShortName;
  }

  openPaypal() {
    this.bitcoinAppService.openPaypal();

    if (this.openPaypalTimeout) clearTimeout(this.openPaypalTimeout);
    this.paypalOpening = true;
    this.openPaypalTimeout = setTimeout(() => {
      this.paypalOpening = false;
    }, PaypalConfig.btnChangingTimeout);
  }
}
